export default "__VITE_ASSET__BPcY22hh__"